import {
  ADD_VEHICLE,
  ADD_VEHICLE_ERROR,
  ADD_VEHICLE_START,
  UPDATE_VEHICLE,
  UPDATE_VEHICLE_ERROR,
  UPDATE_VEHICLE_START,
  GET_VEHICLE,
  GET_VEHICLE_ERROR,
  GET_VEHICLE_LIST_PAGEABLE,
  GET_VEHICLE_LIST_PAGEABLE_START,
  GET_VEHICLE_LIST_PAGEABLE_ERROR,
  DELETE_VEHICLE,
  DELETE_VEHICLE_ERROR,
  DELETE_VEHICLE_START,
  CLEAR_ERROR_VEHICLE,
  GET_VEHICLE_LIST,
  GET_VEHICLE_LIST_ERROR,
  GET_VEHICLE_LIST_START,
} from '../actions/types';

const initialState = {
  emptyList: false,
  vehicleList: [],
  vehicle: {},
  loading: false,
  error: undefined,
  totalElements: '',
  pageNumber: -1,
  pageSize: 8,
  isLastPage: false,
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const addVehicleStart = (state) => {
  return {
    ...state,
    loading: false,
  };
};

const addVehicleError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const addVehicle = (state, action) => {
  return {
    ...state,
    loading: false,
    vehicleList: state.vehicleList.concat(action.payload),
  };
};

const updateVehicleStart = (state) => {
  return {
    ...state,
  };
};

const updateVehicleError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const updateVehicle = (state, action) => {
  return {
    ...state,

    vehicleList: state.vehicleList.map((vehicle) =>
      vehicle.id === action.payload.id ? action.payload : vehicle
    ),
    loading: false,
  };
};

const findAllVehiclePageableStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllVehiclePageableError = (state, action) => {
  return {
    ...state,
    error: action.payload,
  };
};

const findAllVehiclePageable = (state, action) => {
  return {
    ...state,
    vehicleList: [...action.payload.list],
    totalElements: action.payload.totalElements,
  };
};

const deleteVehicleStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const deleteVehicleError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const deleteVehicle = (state, action) => {
  return {
    ...state,
    loading: false,
    vehicleList: state.vehicleList.filter(
      (vehicle) => vehicle.id !== action.payload
    ),
  };
};

const findVehicleByIdStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findVehicleByIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findVehicleById = (state, action) => {
  return {
    ...state,
    loading: false,
    vehicle: action.payload,
  };
};

const findAllVehicleStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllVehicleError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllVehicle = (state, action) => {
  return {
    ...state,
    loading: false,
    vehicleList: action.payload,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_VEHICLE:
      return addVehicle(state, action);
    case ADD_VEHICLE_START:
      return addVehicleStart(state);
    case ADD_VEHICLE_ERROR:
      return addVehicleError(state, action);

    case UPDATE_VEHICLE:
      return updateVehicle(state, action);
    case UPDATE_VEHICLE_START:
      return updateVehicleStart(state);
    case UPDATE_VEHICLE_ERROR:
      return updateVehicleError(state, action);

    case GET_VEHICLE:
      return findVehicleById(state, action);
    case GET_VEHICLE_LIST_START:
      return findVehicleByIdStart(state);
    case GET_VEHICLE_ERROR:
      return findVehicleByIdError(state, action);

    case GET_VEHICLE_LIST_PAGEABLE_START:
      return findAllVehiclePageableStart(state, action);
    case GET_VEHICLE_LIST_PAGEABLE:
      return findAllVehiclePageable(state, action);
    case GET_VEHICLE_LIST_PAGEABLE_ERROR:
      return findAllVehiclePageableError(state, action);

    case DELETE_VEHICLE:
      return deleteVehicle(state, action);
    case DELETE_VEHICLE_START:
      return deleteVehicleStart(state);
    case DELETE_VEHICLE_ERROR:
      return deleteVehicleError(state, action);
    case CLEAR_ERROR_VEHICLE:
      return clearError(state);

    case GET_VEHICLE_LIST:
      return findAllVehicle(state, action);
    case GET_VEHICLE_LIST_START:
      return findAllVehicleStart(state);
    case GET_VEHICLE_LIST_ERROR:
      return findAllVehicleError(state, action);

    default:
      return state;
  }
}
